export default class ReplaceDeviceDto {
  resourOrgId: Array<number> = [];
  targetOrgId: string;
  deviceId: Array<string> = [];
  targetIntId: number;
  targetStringId: string;
  firstWaring: number;
  secondWaring: number;
  thirdWaring: number;
  overUse: number;
  baseUse: number;
  isAll: boolean;
  isReCreate: boolean;
  gatherInter: number;//采集频率分钟
  reportInter: number;//上报频率分钟
  isWrite: boolean;//是否立即写入
  controleType: number;//控制类型
  isPublicConstruction: boolean;//是否为公建
  transferTime: string;
  byCustomer: boolean;//统一客户扣减
  controlExpenses: boolean;//启动以电控费
}